import styled from 'styled-components';

import { breakpoints, Col, SkeletonElement } from '@notino/react-styleguide-v20';

import { IBasicTestProps } from '@styles/model';

interface IDropdownItemsSkeleton {
  disabled: boolean;
}

export const StyledDeliveryCol = styled(Col)`
  flex-direction: column;
  display: flex;
  justify-content: center;
  padding: 0 0 0 1rem;
`;

export const StyledDescriptionSkeleton = styled(SkeletonElement)`
  height: 1rem;

  @media (min-width: ${breakpoints.md}) {
    width: 17.5rem;
  }
`;

export const StyledTitleSkeleton = styled(StyledDescriptionSkeleton)`
  height: 2rem;
  margin-bottom: 0.5rem;
`;

export const StyledDropdownSkeleton = styled.div`
  padding-top: 1rem;
`;

export const StyledDropdownItemsSkeleton = styled.div.attrs<IBasicTestProps>(() => ({}))<IDropdownItemsSkeleton>`
  margin-left: 2rem;
  display: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;
